import { useMutation } from '@tanstack/react-query';
import { requestPasswordRestart } from '@/api/query/passwordRestart';
import { useState } from 'react';

export const useResetPassword = (normalizedEmail, email) => {
	const [isResetModalOpen, setIsResetModalOpen] = useState(false);
	const [resetEmail, setResetEmail] = useState('');
	const [resetMessage, setResetMessage] = useState(null);
	const [resetSuccess, setResetSuccess] = useState(false);

	const resetPasswordMutation = useMutation({
		mutationFn: (emailPayload) => requestPasswordRestart(emailPayload),
		onSuccess: () => {
			setResetMessage(null);
			setResetSuccess(true);
		},
		onError: (res) => {
			setResetSuccess(false);
			setResetMessage(
				res.message ||
					'Error sending reset link. Please check the email address.',
			);
		},
	});

	const openResetModal = () => {
		setResetEmail(normalizedEmail || email);
		setResetMessage(null);
		setResetSuccess(false);
		setIsResetModalOpen(true);
	};

	const closeResetModal = () => {
		setIsResetModalOpen(false);
		setResetEmail('');
		setResetMessage(null);
		setResetSuccess(false);
	};

	const handleResetSubmit = (event) => {
		event.preventDefault();
		setResetMessage(null);

		if (resetEmail) {
			resetPasswordMutation.mutate({ email: resetEmail });
			return;
		}

		setResetMessage('Please enter a valid email address.');
	};

	return {
		isResetModalOpen,
		resetEmail,
		setResetEmail,
		resetMessage,
		resetSuccess,
		isResetLoading: resetPasswordMutation.isPending,
		openResetModal,
		closeResetModal,
		handleResetSubmit,
		handleResetSuccessConfirm: closeResetModal,
	};
};
